var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditDebitCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-4 -4 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4407 11.893H27.6541V15.9864H4.41406V11.893H9.20073M17.5741 20.7197H22.8674M6.84073 24.693C5.5074 24.693 4.41406 23.613 4.41406 22.2664V9.79971C4.41406 8.46638 5.49406 7.37305 6.84073 7.37305H25.2274C26.5607 7.37305 27.6541 8.45305 27.6541 9.79971V22.2664C27.6541 23.5997 26.5741 24.693 25.2274 24.693H6.84073Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0013 11.3337C28.0013 11.7018 27.7028 12.0003 27.3346 12.0003C26.9664 12.0003 26.668 11.7018 26.668 11.3337C26.668 10.9655 26.9664 10.667 27.3346 10.667C27.7028 10.667 28.0013 10.9655 28.0013 11.3337Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditDebitCard);
export default __webpack_public_path__ + "assets/media/creditDebitCard.33114b186a9e20e08333aa6ab0f984a0.svg";
export { ForwardRef as ReactComponent };